import { StatusInscricao } from '../types/inscricao';

export interface InscricaoStatusDisplay {
  value: string;
  label: string;
  color: string;
  bg: string;
}

export function getInscricaoStatusDisplay(input: {
  status?: string | null;
  pagamentoStatus?: string | null;
  isento?: boolean | null;
}): InscricaoStatusDisplay {
  const { status, pagamentoStatus, isento } = input;

  switch (status) {
    case StatusInscricao.CANCELADA:
      return {
        value: StatusInscricao.CANCELADA,
        label: 'Cancelada',
        color: '#6c757d',
        bg: 'rgba(108,117,125,0.2)',
      };
    case StatusInscricao.FILA_ESPERA:
      return {
        value: StatusInscricao.FILA_ESPERA,
        label: 'Fila de espera',
        color: '#dc3545',
        bg: 'rgba(220,53,69,0.2)',
      };
    case StatusInscricao.PENDENTE:
      return {
        value: StatusInscricao.PENDENTE,
        label: 'Pendente',
        color: '#f0ad4e',
        bg: 'rgba(240,173,78,0.2)',
      };
    case StatusInscricao.CONFIRMADA:
      if (pagamentoStatus === 'PAGO') {
        return {
          value: StatusInscricao.CONFIRMADA,
          label: 'Paga',
          color: '#28a745',
          bg: 'rgba(40,167,69,0.2)',
        };
      }
      if (isento === true) {
        return {
          value: StatusInscricao.CONFIRMADA,
          label: 'Isenta',
          color: '#17a2b8',
          bg: 'rgba(23,162,184,0.2)',
        };
      }
      return {
        value: StatusInscricao.CONFIRMADA,
        label: 'Confirmada',
        color: '#28a745',
        bg: 'rgba(40,167,69,0.2)',
      };
    default:
      return {
        value: status ?? '',
        label: status ?? '',
        color: '#6c757d',
        bg: 'rgba(108,117,125,0.2)',
      };
  }
}

export const INSCRICAO_STATUS_FILTER_OPTIONS: { value: string; label: string }[] = [
  { label: 'Pendente', value: StatusInscricao.PENDENTE },
  { label: 'Confirmada', value: StatusInscricao.CONFIRMADA },
  { label: 'Cancelada', value: StatusInscricao.CANCELADA },
  { label: 'Fila de Espera', value: StatusInscricao.FILA_ESPERA },
];
